"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseNumber = exports.parseEmailAddress = exports.parseCreditCardNumber = exports.parsePhoneNumber = exports.parseBSB = void 0;
/**
 * Removes formatting from BSB number
 */
exports.parseBSB = function (input) {
    // Remove anything that's not a number
    var numberString = input.replace(/[^\d]/g, '');
    // Only return the first 6 digits
    return numberString.slice(0, 6);
};
/**
 * Removes formatting from phone number
 */
exports.parsePhoneNumber = function (input) {
    // Remove anything that's not a number, space, +, -, ()
    var numberString = input.replace(/[^\d\s\+\-\(\)]/g, ''); // eslint-disable-line no-useless-escape
    // Max of 15 characters
    return numberString.slice(0, 15);
};
/**
 * Removes formatting from credit card numbers
 */
exports.parseCreditCardNumber = function (input) {
    var numberCount = 0;
    var numbers = '';
    // Copy up to 16 numbers and any spaces to the new numbers string
    /* eslint-disable @typescript-eslint/prefer-for-of */
    for (var i = 0; i < input.length; i += 1) {
        if (input[i] === ' ') {
            // Copy space
            numbers += input[i];
        }
        else if (input[i].match(/\d/)) {
            // Copy number
            numbers += input[i];
            // Don't allow more than 16 numbers
            numberCount += 1;
            if (numberCount >= 16) {
                break;
            }
        }
    }
    /* eslint-enable @typescript-eslint/prefer-for-of */
    return numbers;
};
/**
 * Remove invalid characters from email address
 */
exports.parseEmailAddress = function (input) {
    // Match up to the first invalid character
    // Regex explanation:
    // - From the start of the string /^
    // - Use a non-matching group (?:...) to find more than one char thats not whitespace or
    //   @, Or is the end of string: (?:[^\s\@]|$)+
    // - This is optionally followed by an @
    // - Another non-matching group is used to find the trailing characters. This group is
    //   optional, so it's wrapped in another non-matching group
    var matches = input.match(/^(?:[^\s\@]|$)+\@?(?:(?:[^\s@]|$)+)?/); // eslint-disable-line no-useless-escape
    if (matches === null) {
        return '';
    }
    return matches[0];
};
/**
 * Removes any characters that won't parse to a number
 *
 * Note: this function returns a string
 *
 * @param input
 * @param maximumFractionDigits
 */
exports.parseNumber = function (input, maximumFractionDigits) {
    if (maximumFractionDigits === void 0) { maximumFractionDigits = 16; }
    if (typeof input !== 'string') {
        // Convert to string
        input = String(input); // eslint-disable-line no-param-reassign
    }
    // Remove anything thats not a number, negative, or decimal symbol
    var numberString = input.replace(/[^\d-.]/g, '');
    // Limit the number of fractional part numbers to "maximumFractionDigits". 
    // Regex:
    // - Matches 0 or more digits
    // - Optional negative at start of string
    // - Optional decimal
    // - Up to "maximumFractionDigits" number of decimal places
    var truncateRegex = new RegExp("^(-?\\d{0,}(\\.\\d{0," + maximumFractionDigits + "})?)");
    var matches = numberString.match(truncateRegex);
    if (matches) {
        numberString = matches[0]; // eslint-disable-line prefer-destructuring
    }
    return numberString;
};
